import { defineComponent as _defineComponent } from 'vue'
import { px2vw } from '@/utils/tools'
import { useAsync } from '@/hooks/use-async-2'
import { getAutoIncrementId } from '@/utils/tools'
import { computed, onMounted, reactive, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'kb-flow-image',
  props: {
    src: null,
    fit: { default: 'cover' },
    width: null,
    ratio: null,
    height: null,
    radius: { default: 0 },
    block: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { src: string, fit: 'contain' | 'cover', width?: number | string, ratio?: string, height?: number | string, radius: number | string, block: boolean }



const image_id = 'kb-flow-image-' + getAutoIncrementId()

/**
 *
 * @description 图片加载
 */
function useImage({ src }: { src: string }) {
    const size = reactive({
        width: 0,
        height: 0,
    })

    const { status, request } = useAsync(async () => {
        const image = new Image()
        image.src = src

        return new Promise((resolve) => {
            image.addEventListener('load', () => {
                size.width = image.width
                size.height = image.height

                resolve(size)
            })
        })
    })

    request()

    return { size, status }
}

/**
 * 实现方式, 图片实例只需要设置宽度100%;padding-top值为换算下的比例即可
 * @description 有宽度,没有高度的时候,高度采用百分比方式, 可以这样就可以同时适配宽度是固定尺寸还是百分比情况
 */
function useImageWithNotHeight() {
    const { status, size } = useImage({ src: props.src })

    /** 图片容器样式 */
    const container_style = computed(() => {
        if (status.loading) {
            return {
                width: '100%',
                'padding-top': '0%',
            }
        }

        return {
            width: '100%',
            'padding-top': (size.height / size.width) * 100 + '%',
        }
    })

    /** 图片样式 */
    const image_style = ref({
        'object-fit': props.fit,
        'border-radius': px2vw(props.radius),
    })

    return { status, container_style, image_style }
}

/**
 * @description 图片长宽比
 */
function useImageWithRatio() {
    const { status } = useImage({ src: props.src })

    /** 图片容器样式 */
    const container_style = ref({
        width: '100%',
        'padding-top': props.ratio,
    })

    /** 图片样式 */
    const image_style = ref({
        'object-fit': props.fit,
        'border-radius': px2vw(props.radius),
    })

    return { status, container_style, image_style }
}

/**
 *
 * 实现方式, 容器已经指定了宽高,那么子元素只需要width:100%;height:100%即可
 * @description 父元素同时指定宽高 (宽高都是百分比的情况不考虑)
 */
function useImageWithHeight() {
    /** 图片容器样式 */
    const container_style = ref({
        width: '100%',
        height: '100%',
    })

    /** 图片样式 */
    const image_style = ref({
        'object-fit': props.fit,
        'border-radius': px2vw(props.radius),
    })

    const { status } = useImage({ src: props.src })

    return { status, container_style, image_style }
}

/**
 *
 * @description 图片最外层容器样式
 */
const size_style = computed(() => {
    const result = {
        display: props.block || !props.width ? 'block' : 'inline-block',
        'border-radius': px2vw(props.radius),
    }

    if (props.width) {
        result['width'] = px2vw(props.width)
    }
    if (props.height) {
        result['height'] = px2vw(props.height)
    }

    return result
})

const image_tag = ref<ReturnType<typeof useImageWithNotHeight | typeof useImageWithHeight | typeof useImageWithRatio>>(null)

onMounted(() => {
    /** 图片容器 */
    const image_container = document.querySelector(`#${image_id}`)

    /** 容器高度 */
    const { height: image_container_height } = image_container.getBoundingClientRect()

    if (props.ratio) {
        image_tag.value = reactive(useImageWithRatio())
    } else if (image_container_height) {
        image_tag.value = reactive(useImageWithHeight())
    } else {
        image_tag.value = reactive(useImageWithNotHeight())
    }
})

return { __sfc: true,props, image_id, useImage, useImageWithNotHeight, useImageWithRatio, useImageWithHeight, size_style, image_tag }
}

})